// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"319d8c1a","285":"4e15d0aa","385":"d9a66c99","535":"6847385d","609":"f48f74ef","693":"e18876c8","703":"c149bea5","983":"610c83c2"}[chunkId] + ".chunk.css";
};